import React, { createContext, useContext, useState } from "react";

const EnquiryContext = createContext(null);

export function EnquiryProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openEnquiry = () => setOpen(true);
  return (
    <EnquiryContext.Provider value={{ open, setOpen, openEnquiry }}>
      {children}
    </EnquiryContext.Provider>
  );
}

export const useEnquiry = () => useContext(EnquiryContext);
